if (!customElements.get('tab-information')) {
	class TabInformation extends HTMLElement {
		static get observedAttributes() {
			return ['selected-index'];
		}

		connectedCallback() {
			this.buttons = Array.from(this.querySelectorAll('.tab-information__tab'));
			this.panels = Array.from(this.querySelectorAll('.tab-information__panel'));

			this.applyListIcons();
			this.bindSubtabs();

			this.buttons.forEach((button, index) => {
				button.addEventListener('click', () => {
					this.selectedIndex = index;
				});
			});

			this.selectedIndex = this.selectedIndex;
		}

		applyListIcons() {
			this.panels.forEach((panel) => {
				const template = panel.querySelector('.tab-information__list-icon');
				const source = template && template.content ? template.content.querySelector('svg, img') : null;
				if (!source) return;

				panel.querySelectorAll('.rte ul').forEach((list) => {
					list.classList.add('has-icon-bullets');
					list.querySelectorAll(':scope > li').forEach((item) => {
						if (item.querySelector(':scope > .tab-information__bullet')) return;
						const icon = source.cloneNode(true);
						icon.classList.add('tab-information__bullet');
						icon.removeAttribute('width');
						icon.removeAttribute('height');
						item.prepend(icon);
					});
				});
			});
		}

		// Sub-tabs switch the table and the media of their own panel, matched by index.
		bindSubtabs() {
			this.panels.forEach((panel) => {
				const buttons = Array.from(panel.querySelectorAll('.tab-information__subtab'));
				const subpanels = Array.from(panel.querySelectorAll('.tab-information__subpanel'));

				buttons.forEach((button) => {
					button.addEventListener('click', () => {
						const activeIndex = button.dataset.subtab;

						buttons.forEach((other) => {
							const isActive = other === button;
							other.classList.toggle('active', isActive);
							other.setAttribute('aria-selected', isActive ? 'true' : 'false');
						});

						// A panel can serve several sub-tabs: the tab's own media lists every one without an image.
						subpanels.forEach((subpanel) => {
							subpanel.classList.toggle('active', subpanel.dataset.subtab.split(',').includes(activeIndex));
						});

						this.setMediaState(panel, true);
					});
				});
			});
		}

		get selectedIndex() {
			return parseInt(this.getAttribute('selected-index'), 10) || 0;
		}

		set selectedIndex(index) {
			this.setAttribute('selected-index', index);
		}

		attributeChangedCallback(name, oldValue, newValue) {
			if (name !== 'selected-index' || !this.buttons) return;

			const activeIndex = parseInt(newValue, 10) || 0;

			this.buttons.forEach((button, index) => {
				const isActive = index === activeIndex;
				button.classList.toggle('active', isActive);
				button.setAttribute('aria-selected', isActive ? 'true' : 'false');
				button.setAttribute('tabindex', isActive ? '0' : '-1');
			});

			this.panels.forEach((panel, index) => {
				const isActive = index === activeIndex;
				panel.classList.toggle('active', isActive);
				this.setMediaState(panel, isActive);
			});
		}

		// A video only runs while its tab (and sub-tab) is open, so nothing plays behind a closed panel.
		setMediaState(panel, isActive) {
			panel.querySelectorAll('video').forEach((video) => {
				if (!isActive || video.closest('.tab-information__subpanel:not(.active)')) {
					video.pause();
				} else if (video.autoplay) {
					const playing = video.play();
					if (playing) playing.catch(() => {});
				}
			});
		}
	}

	customElements.define('tab-information', TabInformation);
}
